import { safeDateString, safeDateType } from "../helpers/safeDates";

import { AttributeValue } from "@aws-sdk/client-dynamodb/dist-types/models";

export interface IDomainFederation extends Record<string, unknown> {
  domain: string;
  enabled: boolean;
  domainOwnershipVerified: boolean;
  domainOwnershipVerificationToken: string;
  provider: FederationProvidersEnum | undefined;
  modifiedAt?: Date;
  orgIdOwner: string;
}

export type TDomainFederationKey = keyof IDomainFederation;

export interface IDomainFederationDBItem
  extends Record<TDomainFederationKey, AttributeValue> {
  domain: { S: string };
  enabled: { N: string };
  domainOwnershipVerified: { N: string };
  domainOwnershipVerificationToken: { S: string };
  provider: { S: string };
  modifiedAt: { S: string };
  orgIdOwner: { S: string };
}

export function convertIDomainFederationDBItemToIDomainFederation(
  inp: IDomainFederationDBItem,
): IDomainFederation {
  return {
    domain: inp.domain.S,
    enabled: Boolean(Number(inp.enabled.N)),
    domainOwnershipVerified: Boolean(Number(inp.domainOwnershipVerified.N)),
    domainOwnershipVerificationToken: inp.domainOwnershipVerificationToken.S,
    provider:
      FederationProvidersEnum[inp.provider.S as FederationProvidersEnum],
    modifiedAt: safeDateType(inp.modifiedAt.S),
    orgIdOwner: inp.orgIdOwner.S,
  };
}

export function convertIDomainFederationToIDomainFederationDBItem(
  inp: IDomainFederation,
): IDomainFederationDBItem {
  return {
    domain: { S: inp.domain },
    enabled: { N: inp.enabled ? "1" : "0" },
    domainOwnershipVerified: { N: inp.domainOwnershipVerified ? "1" : "0" },
    domainOwnershipVerificationToken: {
      S: inp.domainOwnershipVerificationToken,
    },
    modifiedAt: { S: safeDateString(inp.modifiedAt) },
    provider: { S: inp.provider ? FederationProvidersEnum[inp.provider] : "" },
    orgIdOwner: { S: inp.orgIdOwner },
  };
}

export enum FederationProvidersEnum {
  Microsoft = "Microsoft",
  Google = "Google",
}
